import React from 'react';
import { ConditionalLink } from '@plone/volto/components';
import config from '@plone/volto/registry';

const DefaultImage = (props) => <img {...props} alt={props.alt || ''} />;

const DienstleistungsListing = ({ items, isEditMode }) => {
  const shortenString = (str, maxLength) => {
    if (!str) return '';
    if (str.length <= maxLength) return str;
    // don't destroy full words
    let shortenedStr = str.substring(0, maxLength);
    // Trim the string to avoid cutting off in the middle of a word
    shortenedStr = shortenedStr.substr(
      0,
      Math.min(shortenedStr.length, shortenedStr.lastIndexOf(' ')),
    );
    return shortenedStr + ' ...';
  };
  const colors = ['red', 'grey', 'white'];
  const Image = config.getComponent('Image').component || DefaultImage;

  return (
    <div className="ui twelve column grid column-grid dienstleistungs-listing">
      {items.map((item, index) => (
        <div
          key={index}
          className={`six wide computer twelve wide mobile six wide tablet column column-blocks-wrapper listing-container slide-down `}
        >
          <ConditionalLink item={item} condition={!isEditMode}>
            {item.image_scales &&
              item.image_scales.preview_image_link &&
              item.image_scales.preview_image_link[0] && (
                <Image
                  item={item}
                  alt={item.alt || 'Vorschaubild für ' + item.title}
                  sizes="(max-width: 768px) 800px, 400px"
                  height="auto"
                  width="100%"
                />
              )}
            <div className={`listing-kachel ${colors[index % colors.length]}`}>
              <h3>{item.title ? shortenString(item.title, 50) : item.id}</h3>
              {item.description && (
                <p>{shortenString(item.description, 100)}</p>
              )}
            </div>
          </ConditionalLink>
        </div>
      ))}
    </div>
  );
};

export default DienstleistungsListing;
